/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Edit_TagsInputs */

const en_dialog_edit_tags = /** @type {(inputs: Dialog_Edit_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Audio Tags`)
};

const es_dialog_edit_tags = /** @type {(inputs: Dialog_Edit_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar etiquetas de audio`)
};

/**
* | output |
* | --- |
* | "Edit Audio Tags" |
*
* @param {Dialog_Edit_TagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_edit_tags = /** @type {((inputs?: Dialog_Edit_TagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Edit_TagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_edit_tags(inputs)
	return en_dialog_edit_tags(inputs)
});